const actionTypes = {
    SET_BESTSELLERS_RECS: 'SET_BESTSELLERS_RECS',
    SET_BESTSELLERS_RECS_ERR: 'SET_BESTSELLERS_RECS_ERR',
    RESET_BESTSELLERS_RECS: 'RESET_BESTSELLERS_RECS'
};

module.exports = actionTypes;
